import { Injectable, EventEmitter } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ServiceRequestWorkorder } from "../../models/ServiceRequestWorkOrderModel";
import { CommunityLotModel } from "../../models/CommunitylotModel";
import { CommunityModel } from "../../models/CommunityModel";
import { Subject } from "rxjs/Subject";
import { DesigncategoryModel } from "../../models/DesignCategoryModel";

@Injectable()
export class SubscriptionService {
    public CommunityLotId$: BehaviorSubject<number>;
    public ContractID$: BehaviorSubject<number>;
    public CommunityLotIdContract$: BehaviorSubject<any>;
    public communityLots: CommunityModel[] = [];
    public uniqueWorkOrderId: BehaviorSubject<string>;
    public designGridChanges$: Subject<DesigncategoryModel>;
    public IsDesignFeatureEnabled$: BehaviorSubject<boolean>;
    public IsWarrantyenable$: BehaviorSubject<boolean>;
    public WarrantyExiprydate$: BehaviorSubject<any>;
    public designDisclosureMessage: string;
    public BuyerInfo$: BehaviorSubject<any>;
    public SurveyTemplateID$: BehaviorSubject<number>;

    constructor() {
        this.CommunityLotId$ = new BehaviorSubject<number>(null);
        this.ContractID$ = new BehaviorSubject<number>(null);
        this.IsDesignFeatureEnabled$ = new BehaviorSubject<boolean>(null);
        this.IsWarrantyenable$ = new BehaviorSubject<boolean>(null);
        this.WarrantyExiprydate$ = new BehaviorSubject<any>(null);
        this.designGridChanges$ = new Subject<DesigncategoryModel>();
        this.uniqueWorkOrderId = new BehaviorSubject<string>(null);
        this.CommunityLotIdContract$ = new BehaviorSubject<any>(null);
        this.BuyerInfo$ = new BehaviorSubject<any>(null);
        this.SurveyTemplateID$ = new BehaviorSubject<number>(null);
    }

    public setCommunityLotId(lotId: number) {
        if (lotId) {
            this.CommunityLotId$.next(lotId);
        }
    }
    public setContractID(contractID: number) {
        if (contractID) {
            this.ContractID$.next(contractID);
        }
    }
    public setBothID(lotId: number, contractId: number) {
        this.CommunityLotIdContract$.next({ lotId: lotId, contractId: contractId })
    }

    public setIsWarrantyenable(isWarrantyenable: boolean) {
        this.IsWarrantyenable$.next(isWarrantyenable);
    }
    public setWarrantyDate(WarrantyExiprydate: any) {
        this.WarrantyExiprydate$.next(WarrantyExiprydate);
    }
    public setSurveyTemplateID(surveytemplateid: number) {
        this.SurveyTemplateID$.next(surveytemplateid)
    }
    // public setBuyerInfo(buyerID: number,isCoBuyer : number,coBuyerID:number) {
    //     // if (BuyerID) {
    //         this.BuyerInfo$.next({buyerID: buyerID, isCoBuyer: isCoBuyer,coBuyerID: coBuyerID})
    //         // this.BuyerID$.next(BuyerID);
    //     // }
    // }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/subscription.service.ts